<template>
  <v-layout row wrap>
    <v-flex xs12 sm6 v-if="config.audits || config.measures || config.favorites">
      <v-layout row wrap>
        <v-flex xs12 sm12 pa-2 v-if="config.audits">
          <AuditWidget/>
        </v-flex>

        <v-flex xs12 sm12 pa-2 v-if="config.favorites">
          <favorite-widget></favorite-widget>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12 sm6 pa-2 v-if="config.measures">
      <measure-widget></measure-widget>
    </v-flex>
  </v-layout>
</template>
  
<script>
import AuditWidget from "@/components/widgets/AuditWidget.vue";
import FavoriteWidget from "@/components/widgets/FavoriteWidget.vue";
import MeasureWidget from "@/components/widgets/MeasureWidget.vue";

import { mapGetters } from "vuex";
import { api as confApi } from "@/store/modules/configuration";

export default {
  name: "dashboard",
  components: {
    AuditWidget,
    FavoriteWidget,
    MeasureWidget
  },
  computed: {
    ...mapGetters(confApi.namespace, [confApi.getters.app]),
    config() {
      if (this.app) {
        let conf = this.app;
        console.log("Konfiguration", conf);
        return conf.components.dashboard || {};
      } else {
        return {};
      }
    }
  }
};
</script>
